/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016-2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.assetLibraryModule', ['bw.paging', 'jquery', 'ngDragDrop', 'ui.router', 'bulbApp.authModule',
  'bulbApp.configModule', 'bulbApp.translateModule'])
.constant('ASSET_LIBRARY', {
  FILTER: {
    IMAGE:'image/heic,image/bmp,image/webp,image/jpeg,image/gif,image/png,image/psd,image/tiff,image/x-portable-anymap,' +
        'image/vnd.zbrush.pcx,image/x-pcx,image/sgi,image/pcx,image/ppm,image/pbm,image/heif',
    VIDEO: 'video/mp4,video/3gpp,video/3gpp2,video/x-ms-asf,video/avi,video/x-flv,' +
      'video/x-matroska,video/quicktime,video/mpeg,video/x-ms-vob,video/x-ms-wmv',
    ATTACHED_FILE: '*',
    AUDIO: 'audio/m4a,audio/x-m4a,audio/*,audio/mp3,audio/wav'

},
  CROP: {
    MIN_CROP_WIDTH:  50,
    MIN_CROP_HEIGHT: 50,
    MAX_IMAGE_SIZE_ON_LARGE_DISPLAY: 500,
    MAX_IMAGE_SIZE_ON_MEDIUM_DISPLAY: 350
  },
  ROTATE: {
    CONSTANT_ROTATION_DEGREE: 90,
    IMAGE_ASPECT_RATIO_THRESHOLD: 1.25,
    IMAGE_HEIGHT_RATIO: 4,
    INITIAL_START_DEGREE: 0
  }
})
.run(['$rootScope', '$window', 'ASSET_LIBRARY', function($rootScope, $window, ASSET_LIBRARY) {
  $rootScope.ASSET_LIBRARY = ASSET_LIBRARY;
  // Needed so that CKE plugins have access to values:
  $window.bulbVars.ASSET_LIBRARY = ASSET_LIBRARY;
}])
.config(['$stateProvider', 'AUTH', function($stateProvider, AUTH) {
    $stateProvider
        .state('assetlibrary', {
      parent: 'root',
            url: '^/b/assetlibrary',
            views: {
                'content@root': {
                    templateUrl: 'ajs/assetlibrary/assetlibrary.html',
                    controller: 'AssetLibraryController as assetLibraryCtrl'
                }
            },
      resolve: {
        $title: ['$translate', ($translate) => $translate('asset_library_title')],
      },
      bulbAuth: {
        authorizedRoles: [AUTH.ROLES.REGISTERED_USER]
      }
        });
}]);
